import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLanguage } from '@constants/index';
import type { RootState } from '@store/store';
import type { IL10n, IDataMap, IDataByDateMap } from '@type/index';

export interface UiState {
  l10n: IL10n | null;
  categoryList: string[];
  subCategoryList: string[];
  dataMap: IDataMap; // api 응답 데이터를 {['카테고리id-아이템id']: 데이터} 해시맵 구조로 변경한 데이터
  dataByDateMap: IDataByDateMap; // 일별 노출할 데이터의 키값을 모아둔 배열 데이터
}

const initialState: UiState = {
  l10n: null,
  categoryList: [],
  subCategoryList: [],
  dataMap: {},
  dataByDateMap: {},
};

// getL10N
export const dynamicImportL10N = createAsyncThunk('ui/setL10N', async () => {
  const language = getLanguage();
  return await import(
    // webpack - magic comments (지우지 마세요)
    /*
                webpackInclude: /\.json$/,
                webpackMode: "lazy",
                webpackChunkName: "[request]"
            */
    `/src/ts/common/l10n/${language}.json`
  ).then((res) => res?.default);
});

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCategoryList(state, action) {
      state.categoryList = action?.payload;
    },
    setSubCategoryList(state, action) {
      state.subCategoryList = action?.payload;
    },
    setDataMap(state, action) {
      state.dataMap = action?.payload;
    },
    setDataByDateMap(state, action) {
      state.dataByDateMap = action?.payload;
    },
    resetData(state) {
      state.dataMap = {};
      state.dataByDateMap = {};
    },
  },
  extraReducers: (builder) => {
    builder?.addCase(dynamicImportL10N?.fulfilled, (state, action) => {
      state.l10n = action?.payload;
    });
  },
});

export const { setCategoryList, setSubCategoryList, setDataMap, setDataByDateMap, resetData } = uiSlice.actions;

export const selectedL10N = (state: RootState) => state?.ui?.l10n;
export const selectedCategoryList = (state: RootState) => state?.ui?.categoryList;
export const selectedSubCategoryList = (state: RootState) => state?.ui?.subCategoryList;
export const selectedDataMap = (state: RootState) => state?.ui?.dataMap;
export const selectedDataByDateMap = (state: RootState) => state?.ui?.dataByDateMap;
export const selectedIsShowCalendarMark = (state: RootState) => state?.ui?.categoryList?.length > 0;

export default uiSlice.reducer;
